"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _initializerDefineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerDefineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));
var _initializerWarningHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerWarningHelper"));
var _mobx = require("mobx");
var _search = require("../../utils/search.utils");
var _size2 = _interopRequireDefault(require("lodash/size"));
var _keyBy2 = _interopRequireDefault(require("lodash/keyBy"));
var _keys2 = _interopRequireDefault(require("lodash/keys"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _asyncSearchResultsV = _interopRequireDefault(require("../api/async-search-results-v2.store"));
var _stepPageStore = _interopRequireDefault(require("./step-page-store"));
var _marketingBanners = _interopRequireDefault(require("../api/marketing-banners.store"));
var _combinedItinerary = _interopRequireDefault(require("../../factories/combined-itinerary.factory"));
var _constants = require("../../constants");
var _mobxUtils = require("mobx-utils");
var _filters = require("../../constants/filters.constants");
var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _class, _descriptor, _descriptor2, _descriptor3;
var StepByStepSearchPageStore = exports.default = (_dec = _mobx.action.bound, _dec2 = _mobx.action.bound, _dec3 = _mobx.action.bound, _dec4 = _mobx.action.bound, _dec5 = _mobx.action.bound, _dec6 = _mobx.action.bound, _dec7 = _mobx.action.bound, _dec8 = _mobx.action.bound, _dec9 = _mobx.action.bound, _dec10 = _mobx.action.bound, _dec11 = _mobx.action.bound, (_class = function () {
  function StepByStepSearchPageStore(initialState, $env, flightInfo) {
    var _this = this;
    if (initialState === void 0) {
      initialState = {};
    }
    (0, _classCallCheck2.default)(this, StepByStepSearchPageStore);
    (0, _initializerDefineProperty2.default)(this, "easyApplyFiltersApplied", _descriptor, this);
    (0, _initializerDefineProperty2.default)(this, "syncedFilters", _descriptor2, this);
    (0, _initializerDefineProperty2.default)(this, "preservedFilters", _descriptor3, this);
    this.$env = void 0;
    this.searchResults = {};
    this.marketingBanners = void 0;
    this.outbound = void 0;
    this.inbound = void 0;
    this.getCombinedItinerary = (0, _mobxUtils.computedFn)(function (itineraryType) {
      if (!_this.inbound[itineraryType] || !_this.outbound[itineraryType]) return null;
      return (0, _combinedItinerary.default)({
        outbound: _this.outbound.searchResults.getItinerary(_this.outbound[itineraryType].id),
        inbound: _this.inbound.searchResults.getItinerary(_this.inbound[itineraryType].id),
        $currency: _this.$env.currency
      });
    });
    this.$env = $env;
    this.marketingBanners = new _marketingBanners.default(initialState.marketingBanners, $env);
    this.outbound = new _stepPageStore.default({
      direction: _constants.OUTBOUND,
      searchResults: new _asyncSearchResultsV.default(initialState.searchResults, $env)
    }, $env, flightInfo);
    this.inbound = new _stepPageStore.default({
      direction: _constants.INBOUND,
      searchResults: new _asyncSearchResultsV.default(initialState.searchResults, $env)
    }, $env, flightInfo);
    (0, _mobx.autorun)(function () {
      if (_this.outbound.selectedItinerary) {
        _this.inbound.setOutboundItinerary(_this.outbound.selectedItinerary);
      }
    });
  }
  (0, _createClass2.default)(StepByStepSearchPageStore, [{
    key: "currentStep",
    get: function get() {
      return this.outbound.selectedItinerary ? _constants.INBOUND : _constants.OUTBOUND;
    }
  }, {
    key: "currentStepStore",
    get: function get() {
      return this[this.currentStep];
    }
  }, {
    key: "searchRoute",
    get: function get() {
      return (0, _search.getRouteFromQuery)(this.currentStepStore.searchResults.searchQuery);
    }
  }, {
    key: "marketingCampaigns",
    get: function get() {
      var _this$currentStepStor = this.currentStepStore.searchResults.searchRequest,
        isDomesticKSA = _this$currentStepStor.isDomesticKSA,
        searchType = _this$currentStepStor.searchType;
      return this.marketingBanners.getValidCampaigns({
        route: this.searchRoute,
        airlines: this.currentStepStore.searchResults.airlineCodes,
        searchType: searchType,
        isDomesticKSA: isDomesticKSA
      });
    }
  }, {
    key: "topCampaign",
    get: function get() {
      var _this$currentStepStor2 = this.currentStepStore.searchResults.searchRequest,
        isDomesticKSA = _this$currentStepStor2.isDomesticKSA,
        searchType = _this$currentStepStor2.searchType;
      return this.marketingBanners.topCampaign({
        route: this.searchRoute,
        airlines: this.currentStepStore.searchResults.airlineCodes,
        searchType: searchType,
        isDomesticKSA: isDomesticKSA
      });
    }
  }, {
    key: "marketingCampaignsMap",
    get: function get() {
      return (0, _keyBy2.default)(this.marketingCampaigns, function (campaign) {
        return campaign.position;
      });
    }
  }, {
    key: "haveNoResultsFilters",
    get: function get() {
      return (0, _size2.default)(this.outbound.filters.filter(this.inbound.allSearchResults)) < 1;
    }
  }, {
    key: "haveNoCommonFilters",
    get: function get() {
      var _this2 = this;
      var outBoundStopFilter = this.outbound.filters[_filters.FILTER_MAP.STOP];
      var outBoundAirlineFilter = this.outbound.filters[_filters.FILTER_MAP.AIRLINE];
      var outBoundBaggageFilter = this.outbound.filters[_filters.FILTER_MAP.BAGGAGE];
      var commonStop = false;
      var commonAirline = false;
      var commonBaggage = false;
      if (outBoundStopFilter.isDirty && outBoundStopFilter.selectedItem !== undefined) {
        commonStop = this.inbound.filters[_filters.FILTER_MAP.STOP].state.some(function (s) {
          return s.code === outBoundStopFilter.selectedItem && s.isAvailable;
        });
      }
      if (outBoundAirlineFilter.isDirty && outBoundAirlineFilter.params.length > 0) {
        commonAirline = outBoundAirlineFilter.params.some(function (airlineCode) {
          return _this2.inbound.filters[_filters.FILTER_MAP.AIRLINE].state.some(function (s) {
            return s.code === airlineCode;
          });
        });
      }
      if (outBoundBaggageFilter.isDirty && outBoundBaggageFilter.params.length > 0) {
        commonBaggage = outBoundBaggageFilter.params.some(function (baggageCode) {
          return _this2.inbound.filters[_filters.FILTER_MAP.BAGGAGE].state.some(function (s) {
            return s.code === baggageCode && s.isAvailable === true;
          });
        });
      }
      return !commonAirline && !commonBaggage && !commonStop;
    }
  }, {
    key: "isSameFiltersApplied",
    get: function get() {
      var outBoundStopFilter = this.outbound.filters[_filters.FILTER_MAP.STOP];
      var outBoundAirlineFilter = this.outbound.filters[_filters.FILTER_MAP.AIRLINE];
      var outBoundBaggageFilter = this.outbound.filters[_filters.FILTER_MAP.BAGGAGE];
      var sameFilterOnStop = outBoundStopFilter.selectedItem === this.inbound.filters[_filters.FILTER_MAP.STOP].selectedItem;
      var sameFilterOnAirline = outBoundAirlineFilter.params.length === 0 && this.inbound.filters[_filters.FILTER_MAP.AIRLINE].params.length === 0;
      var sameFilterOnBaggage = outBoundBaggageFilter.params.length === 0 && this.inbound.filters[_filters.FILTER_MAP.BAGGAGE].params.length === 0;
      if (outBoundAirlineFilter.params.length > 0) {
        var airlineSet = new Set(this.inbound.filters[_filters.FILTER_MAP.AIRLINE].params);
        sameFilterOnAirline = outBoundAirlineFilter.params.every(function (airlineCode) {
          return airlineSet.has(airlineCode);
        });
      }
      if (outBoundBaggageFilter.params.length > 0) {
        var inboundBaggageSet = new Set(this.inbound.filters[_filters.FILTER_MAP.BAGGAGE].params);
        sameFilterOnBaggage = outBoundBaggageFilter.params.every(function (baggageCode) {
          return inboundBaggageSet.has(baggageCode);
        });
      }
      return sameFilterOnStop && sameFilterOnAirline && sameFilterOnBaggage;
    }
  }, {
    key: "showEasyApplyFilters",
    get: function get() {
      var haveEasyFilters = this.outbound.filters.filterList.airline.isDirty || this.outbound.filters.filterList.airline.isTouched || this.outbound.filters.filterList.baggage.isDirty || this.outbound.filters.filterList.baggage.isTouched || this.outbound.filters.filterList.stop.isDirty || this.outbound.filters.filterList.stop.isTouched;
      return this.currentStep === "inbound" && !this.easyApplyFiltersApplied && haveEasyFilters && !this.haveNoCommonFilters && !this.isSameFiltersApplied;
    }
  }, {
    key: "preserveCurrentFilters",
    value: function preserveCurrentFilters() {
      this.preservedFilters = {
        stop: this.currentStepStore.filters[_filters.FILTER_MAP.STOP].state,
        airline: this.currentStepStore.filters[_filters.FILTER_MAP.AIRLINE].state,
        baggage: this.currentStepStore.filters[_filters.FILTER_MAP.BAGGAGE].state,
        price: this.currentStepStore.filters[_filters.FILTER_MAP.PRICE].state,
        airport: this.currentStepStore.filters[_filters.FILTER_MAP.AIRPORT].state,
        time: this.currentStepStore.filters[_filters.FILTER_MAP.TIME].state
      };
    }
  }, {
    key: "restorePreservedFilters",
    value: function restorePreservedFilters() {
      if ((0, _isEmpty2.default)(this.preservedFilters)) return;
      this.currentStepStore.filters.setRestoringPreservedFilters(true);
      this.currentStepStore.filters[_filters.FILTER_MAP.STOP].clone(this.preservedFilters.stop);
      this.currentStepStore.filters[_filters.FILTER_MAP.AIRLINE].clone(this.preservedFilters.airline);
      this.currentStepStore.filters[_filters.FILTER_MAP.BAGGAGE].clone(this.preservedFilters.baggage);
      this.currentStepStore.filters[_filters.FILTER_MAP.PRICE].clone(this.preservedFilters.price);
      this.currentStepStore.filters[_filters.FILTER_MAP.AIRPORT].clone(this.preservedFilters.airport);
      this.currentStepStore.filters[_filters.FILTER_MAP.TIME].clone(this.preservedFilters.time);
      this.currentStepStore.fareCalendar.setFiltersQuery(this.currentStepStore.filters.queryStr);
    }
  }, {
    key: "restoreStopFilters",
    value: function restoreStopFilters() {
      this.currentStepStore.filters[_filters.FILTER_MAP.STOP].clone(this.preservedFilters.stop);
    }
  }, {
    key: "restoreAirlineFilters",
    value: function restoreAirlineFilters() {
      this.currentStepStore.filters[_filters.FILTER_MAP.AIRLINE].clone(this.preservedFilters.airline);
    }
  }, {
    key: "restoreBaggageFilters",
    value: function restoreBaggageFilters() {
      this.currentStepStore.filters[_filters.FILTER_MAP.BAGGAGE].clone(this.preservedFilters.baggage);
    }
  }, {
    key: "restorePriceFilters",
    value: function restorePriceFilters() {
      if (this.preservedFilters.price.to === this.preservedFilters.price.max) {
        return;
      }
      if (this.currentStepStore.filters[_filters.FILTER_MAP.PRICE].state.max > this.preservedFilters.price.to) {
        this.currentStepStore.filters[_filters.FILTER_MAP.PRICE].clone(this.preservedFilters.price);
      }
    }
  }, {
    key: "restoreAirportFilters",
    value: function restoreAirportFilters() {
      this.currentStepStore.filters[_filters.FILTER_MAP.AIRPORT].clone(this.preservedFilters.airport);
    }
  }, {
    key: "restoreTimeFilters",
    value: function restoreTimeFilters() {
      this.currentStepStore.filters[_filters.FILTER_MAP.TIME].clone(this.preservedFilters.time);
    }
  }, {
    key: "cleanPreservedFilters",
    value: function cleanPreservedFilters() {
      this.preservedFilters = {};
    }
  }, {
    key: "syncFilters",
    value: function syncFilters() {
      var syncedFilters = {
        stop: true,
        airline: true,
        baggage: true
      };
      var outBoundStopFilter = this.outbound.filters[_filters.FILTER_MAP.STOP];
      var outBoundAirlineFilter = this.outbound.filters[_filters.FILTER_MAP.AIRLINE];
      var outBoundBaggageFilter = this.outbound.filters[_filters.FILTER_MAP.BAGGAGE];
      var inBoundStopFilter = this.inbound.filters[_filters.FILTER_MAP.STOP];
      var inBoundAirlineFilter = this.inbound.filters[_filters.FILTER_MAP.AIRLINE];
      var inBoundBaggageFilter = this.inbound.filters[_filters.FILTER_MAP.BAGGAGE];
      inBoundStopFilter.clone(outBoundStopFilter.state);
      if ((0, _size2.default)(this.inbound.filteredSearchResults) < 1) {
        inBoundStopFilter.reset(true);
        delete syncedFilters.stop;
      }
      inBoundAirlineFilter.clone(outBoundAirlineFilter.state);
      if ((0, _size2.default)(this.inbound.filteredSearchResults) < 1) {
        inBoundAirlineFilter.reset(true);
        delete syncedFilters.airline;
      }
      inBoundBaggageFilter.clone(outBoundBaggageFilter.state);
      if ((0, _size2.default)(this.inbound.filteredSearchResults) < 1) {
        inBoundBaggageFilter.reset(true);
        delete syncedFilters.baggage;
      }
      this.syncedFilters = (0, _keys2.default)(syncedFilters);
    }
  }, {
    key: "applyEasyApplyFilters",
    value: function applyEasyApplyFilters(isApply) {
      if (isApply === void 0) {
        isApply = false;
      }
      if (isApply) {
        this.syncFilters();
      }
      this.easyApplyFiltersApplied = !isApply;
    }
  }]);
  return StepByStepSearchPageStore;
}(), (_descriptor = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "easyApplyFiltersApplied", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor2 = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "syncedFilters", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor3 = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "preservedFilters", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "currentStep", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "currentStep"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "currentStepStore", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "currentStepStore"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "searchRoute", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "searchRoute"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "marketingCampaigns", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "marketingCampaigns"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "topCampaign", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "topCampaign"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "marketingCampaignsMap", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "marketingCampaignsMap"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "haveNoResultsFilters", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "haveNoResultsFilters"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "haveNoCommonFilters", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "haveNoCommonFilters"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "isSameFiltersApplied", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isSameFiltersApplied"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "showEasyApplyFilters", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "showEasyApplyFilters"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "preserveCurrentFilters", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "preserveCurrentFilters"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "restorePreservedFilters", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "restorePreservedFilters"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "restoreStopFilters", [_dec3], Object.getOwnPropertyDescriptor(_class.prototype, "restoreStopFilters"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "restoreAirlineFilters", [_dec4], Object.getOwnPropertyDescriptor(_class.prototype, "restoreAirlineFilters"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "restoreBaggageFilters", [_dec5], Object.getOwnPropertyDescriptor(_class.prototype, "restoreBaggageFilters"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "restorePriceFilters", [_dec6], Object.getOwnPropertyDescriptor(_class.prototype, "restorePriceFilters"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "restoreAirportFilters", [_dec7], Object.getOwnPropertyDescriptor(_class.prototype, "restoreAirportFilters"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "restoreTimeFilters", [_dec8], Object.getOwnPropertyDescriptor(_class.prototype, "restoreTimeFilters"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "cleanPreservedFilters", [_dec9], Object.getOwnPropertyDescriptor(_class.prototype, "cleanPreservedFilters"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "syncFilters", [_dec10], Object.getOwnPropertyDescriptor(_class.prototype, "syncFilters"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "applyEasyApplyFilters", [_dec11], Object.getOwnPropertyDescriptor(_class.prototype, "applyEasyApplyFilters"), _class.prototype)), _class));